import {
  type KnowledgeBaseSuggestionArgs,
  type KnowledgeBaseSuggestionParams,
  type SuggestionArgs,
} from '@/extensions/Mention/types'

import { fuzzyMatch } from '@/helpers/string'

export const isKnowledgeBaseSuggestionArgs = (
  args: SuggestionArgs | undefined,
): args is KnowledgeBaseSuggestionArgs => {
  return args?.type === 'knowledge-base'
}

export const getKnowledgeBaseSuggestionParams = (
  suggestion: SuggestionArgs | undefined,
): KnowledgeBaseSuggestionParams => {
  return isKnowledgeBaseSuggestionArgs(suggestion)
    ? suggestion
    : {
        pursuitId: '',
        orgId: '',
      }
}

export const getItemsWithQuery = <T>(
  items: T[],
  query: string,
  getLabel: (item: T) => string,
) => {
  if (!query) return items
  return items.filter((item) => fuzzyMatch(getLabel(item), query))
}
